import React from 'react'
import Image from 'gatsby-image'
import { Link } from 'gatsby'

const SectionTextImage = ({ title, text, fluid, bg, linkSlug, linkText }) => {
  return (
    <section className={`section--text-image full-width padding ${bg}`}>
      <div className="grid-container">
        <div className="grid-x grid-margin-x align-middle">
          <div className="cell medium-6">
            <h2 className="text-capitalize mb-2 text-center">{title}</h2>
            <div className="mb-3">{text}</div>
            <Link className="button white centered" to={`/${linkSlug}`}>
              {linkText}
            </Link>
          </div>
          <div className="cell medium-6">
            <Image fluid={fluid} loading="eager" durationFadeIn={250}/>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SectionTextImage
